import { faDownload, faKey } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalCloseButton, ModalFooter, ModalHeader, ModalTitle } from '@tryhackme/thm-ui-components';
import { StyledModalContent, StyledModalIcon, StyledModalWrapper } from '../cdd-access.styles';
interface GeneratePemModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  pemContent: string;
  username: string;
  type: 'internal' | 'external';
}
const handleDownload = (pemContent: string, username: string, type: 'internal' | 'external') => {
  const blob = new Blob([pemContent], {
    type: 'text/plain'
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${username}-content-dev-${type}.pem`;
  document.body.append(a);
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};
export const GeneratePemModal = ({
  isOpen,
  onOpenChange,
  pemContent,
  username,
  type
}: GeneratePemModalProps) => <Modal open={isOpen} isSmall onOpenChange={onOpenChange} data-sentry-element="Modal" data-sentry-component="GeneratePemModal" data-sentry-source-file="generate-pem-modal.tsx">
    <StyledModalWrapper data-sentry-element="StyledModalWrapper" data-sentry-source-file="generate-pem-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="generate-pem-modal.tsx">
        <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="generate-pem-modal.tsx">
          <StyledModalIcon data-sentry-element="StyledModalIcon" data-sentry-source-file="generate-pem-modal.tsx">
            <FontAwesomeIcon icon={faKey} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="generate-pem-modal.tsx" />
          </StyledModalIcon>
          Generated PEM Key
        </ModalTitle>
      </ModalHeader>
      <StyledModalContent data-sentry-element="StyledModalContent" data-sentry-source-file="generate-pem-modal.tsx">
        <p>Your PEM key has been generated. Click the button below to download it.</p>
        <Button onClick={() => handleDownload(pemContent, username, type)} variant="solid" color="primary" data-sentry-element="Button" data-sentry-source-file="generate-pem-modal.tsx">
          <StyledModalIcon data-sentry-element="StyledModalIcon" data-sentry-source-file="generate-pem-modal.tsx">
            <FontAwesomeIcon icon={faDownload} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="generate-pem-modal.tsx" />
          </StyledModalIcon>
          Download PEM Key
        </Button>
      </StyledModalContent>
      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="generate-pem-modal.tsx">
        <ModalCloseButton text="Close" data-sentry-element="ModalCloseButton" data-sentry-source-file="generate-pem-modal.tsx" />
      </ModalFooter>
    </StyledModalWrapper>
  </Modal>;